import { render, staticRenderFns } from "./myRedInfo.vue?vue&type=template&id=64ba7957&scoped=true"
import script from "./myRedInfo.vue?vue&type=script&lang=js"
export * from "./myRedInfo.vue?vue&type=script&lang=js"
import style0 from "./myRedInfo.vue?vue&type=style&index=0&id=64ba7957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba7957",
  null
  
)

export default component.exports